/* Runtime config for the compatible-parts table.
 *
 * There is no build step — edit the values here, push the theme, done. The
 * loader (compatible-parts-loader.js) reads this at startup and falls back to
 * these same defaults if this file is missing or fails to load, so the table
 * never breaks because of a typo here.
 */
window.CP_CONFIG = {
  // Parts with no custom.part_category metafield (or one pointing at a category
  // node that no longer exists) are collected into a catch-all group.
  //   true  - show that group
  //   false - hide those parts entirely
  // Either way the loader logs how many turned up, so check the browser console
  // if you are unsure whether a part is landing here.
  showUncategorized: true,

  // Label on the catch-all group's bar.
  uncategorizedLabel: 'Other',

  // Where the catch-all sorts among the top-level categories. Infinity puts it
  // last; use a number to slot it in against the categories' sort_num values.
  uncategorizedOrder: Infinity
};
